webpackJsonp([241891719824365],{

/***/ 819:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/1.1b24cc09.png";

/***/ }),

/***/ 820:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/2.0e4a31fe.png";

/***/ }),

/***/ 821:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/3.902f90c7.png";

/***/ }),

/***/ 822:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/4.3b9c596e.png";

/***/ }),

/***/ 1150:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactTypist = __webpack_require__(28);
	
	var _reactTypist2 = _interopRequireDefault(_reactTypist);
	
	__webpack_require__(27);
	
	var _messages = __webpack_require__(34);
	
	var _messages2 = _interopRequireDefault(_messages);
	
	var _HeadlineWithFocus = __webpack_require__(6);
	
	var _HeadlineWithFocus2 = _interopRequireDefault(_HeadlineWithFocus);
	
	var _ = __webpack_require__(819);
	
	var _2 = _interopRequireDefault(_);
	
	var _3 = __webpack_require__(820);
	
	var _4 = _interopRequireDefault(_3);
	
	var _5 = __webpack_require__(821);
	
	var _6 = _interopRequireDefault(_5);
	
	var _7 = __webpack_require__(822);
	
	var _8 = _interopRequireDefault(_7);
	
	var _reactResponsiveEmbed = __webpack_require__(26);
	
	var _reactResponsiveEmbed2 = _interopRequireDefault(_reactResponsiveEmbed);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Index = function Index(props) {
	  return _react2.default.createElement(
	    'div',
	    { className: 'c-content-box' },
	    _react2.default.createElement(
	      'h2',
	      null,
	      'Tesi di laurea triennale'
	    ),
	    _react2.default.createElement(
	      'div',
	      { style: { textAlign: 'justify', lineHeight: '2em' } },
	      _react2.default.createElement('img', { src: _2.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Generalit\xE0'
	      ),
	      'Il presente lavoro di tesi \xE8 incentrato sullo studio del comportamento meccanico, con particolare riferimento alla resistenza a taglio, di calcestruzzi la cui composizione \xE8 ottenuta effettuando una sostituzione di parte degli aggregati grossi con aggregati derivanti dal riciclo di rifiuti da costruzione e demolizione di manufatti edili e/o civili. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _4.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Dettagli del lavoro'
	      ),
	      'Questi studi sono basati su prove di laboratorio su provini cubici, cilindrici e infine travetti in calcestruzzo armato. E\u2019 stato studiato il campo di applicazione di questo tipo di aggregato sia in Italia che a livello europeo e mondiale. E\u2019 presentato uno stato dell\u2019arte dettagliato relativo al mix design di calcestruzzi realizzati tramite l\u2019impiego di aggregati derivanti dal riciclo. Nel capitolo 4 \xE8 inoltre descritto lo stato dell\u2019arte relativo al comportamento a taglio delle strutture in calcestruzzo armato con particolare riferimento alla \u201CModified Compression Field Theory\u201D di Frank J. Vecchio e Michael P. Collins. Infine si \xE8 studiato un modello agli elementi finiti con il software \u201CResponse2000\u201D volto a valutare lo stato tensionale presente nei travetti durante la prova di flessione-taglio. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement(_reactResponsiveEmbed2.default, { src: 'https://www.youtube.com/embed/bgeHvoaSNec', allowFullScreen: true }),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _6.default, style: { width: '100%', height: '100%' } }),
	      _react2.default.createElement(
	        'h3',
	        null,
	        'Risultati principali'
	      ),
	      'Il presente studio ha consentito di evidenziare comportamenti che la classica teoria MCFT non \xE8 in grado di cogliere con esattezza e che possono rappresentare la base per futuri approfondimenti nello stesso settore di ricerca. ',
	      _react2.default.createElement('br', null),
	      ' ',
	      _react2.default.createElement('br', null),
	      _react2.default.createElement('img', { src: _8.default, style: { width: '100%', height: '100%' } })
	    )
	  );
	};
	
	exports.default = Index;
	module.exports = exports['default'];

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-bachelor-it-jsx-338237fcc85820e594ca.js